module.exports = __webpack_public_path__ + "img/合约发布.3a02d88a.jpg";